<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Selecione um Mês </v-card-title>

        <v-select
          :items="$constants.mesesPlanoSemanal"
          item-text="descricao"
          item-value="id"
          v-model="mes"
          return-object
          label="Selecione um mês"
          solo
        ></v-select>

        <v-select
          :items="$constants.semanas"
          item-text="descricao"
          item-value="id"
          v-model="semana"
          return-object
          label="Selecione uma semana"
          solo
        ></v-select>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelar">Cancelar</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="isDisabled"
            @click="gerarPlanoSemanal(gestaoDeAulasId, mes.id, semana.id)"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    gestaoDeAulasId: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    typeModel: {
      type: String,
    },
  },

  watch: {
    dialog(val) {
      this.$emit("status", val);
    },
    typeModel(val) {
      this.type = val;
    },
  },
  data() {
    return {
      type: null,
      mes: null,
      semana: null, // Adicionando a variável semana
    };
  },
  computed: {
    isDisabled() {
      return !this.mes || !this.semana;
    },
  },
  methods: {
    async gerarPlanoSemanal(gestaoDeAulasId, mesId, semanaId) {
      try {
        this.$loaderService.open("Gerando plano semanal...");
        await this.$services.relatoriosService.planoSemanalInfantil(
          parseInt(gestaoDeAulasId, 10),
          parseInt(mesId, 10),
          parseInt(semanaId, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    cancelar() {
      this.mes = null;
      this.semana = null; // Resetando a semana ao cancelar
      this.$emit("status", false);
    },
  },
};
</script>
